import { render, staticRenderFns } from "./baoxian.vue?vue&type=template&id=0aca4548&scoped=true"
import script from "./baoxian.vue?vue&type=script&lang=js"
export * from "./baoxian.vue?vue&type=script&lang=js"
import style0 from "./baoxian.vue?vue&type=style&index=0&id=0aca4548&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca4548",
  null
  
)

export default component.exports